import PropTypes from "prop-types";
import React from "react";
import useFluxStore from "@armus/use-flux-store";
import lockStore from "../../../data/lockStore";
import LockMessage from "lib/lock/LockMessage";
import { MERGE_CONTEXT } from "data/MergeStore";

const MergeBodyLayoutView = (props) => {
    const {
        isMagicRoot,
        sourceLabel,
        targetLabel,
        typeLabel,
        sourceChildren,
        targetOptlock,
        sourceOptlock,
        targetPesslock,
        sourcePesslock,
        onCancel,
        onMerge,
        children
    } = props;
    const optlockViolated = (targetOptlock && targetOptlock.violated)
        || (sourceOptlock && sourceOptlock.violated);
    return (
        <div className="merge-content">
            <div className="row merge-header">
                <div className="col-md-12">
                    { sourceLabel } <img alt="" src="images/mapping_arrow.svg"/> { targetLabel }
                </div>
            </div>
            <div className="row merge-action-bar">
                <div className="col-md-12">
                    {!optlockViolated && <button type="button" className="btn btn-merge btn-primary" onClick={onMerge}><span /> Merge</button>}
                    <button type="button" className="btn btn-cancel" onClick={onCancel}><span /> Cancel</button>
                    <LockMessage lock={targetPesslock} label={targetLabel} />
                    <LockMessage lock={sourcePesslock} label={sourceLabel} />
                </div>
            </div>
            <div className="merge-body">
                Clicking the MERGE button will:
                <ol>
                    {!isMagicRoot ? (
                        <li>Change all references FROM {sourceLabel} TO {targetLabel}</li>
                    ) : (
                        <li>Move the following FROM the selected {typeLabel} {sourceLabel}:
                            <ul>
                                {sourceChildren.map(g => (
                                    // combine all children to same level.
                                    g.items.map((l, i) => <li key={i}>{l}</li>)
                                ))}
                            </ul>
                            TO {typeLabel} {targetLabel}.
                        </li>
                    )}
                    <li>Update {typeLabel} data for selected fields from the Pre-Mapped value to the Post-Mapped value. (Uncheck any field to retain the pre-mapped value.)</li>
                    <li>Delete the FROM {typeLabel} {sourceLabel}</li>
                </ol>

                {children}
            </div>
        </div>
    );
};

MergeBodyLayoutView.propTypes = {
    isMagicRoot: PropTypes.bool,
    fluxContext: PropTypes.string.isRequired,
    targetLabel: PropTypes.any.isRequired,
    sourceLabel: PropTypes.any,
    typeLabel: PropTypes.string.isRequired,
    sourceChildren: PropTypes.array.isRequired,
    sourceOptlock: PropTypes.any,
    sourcePesslock: PropTypes.any,
    targetOptlock: PropTypes.any,
    targetPesslock: PropTypes.any,
    onCancel: PropTypes.func.isRequired,
    onMerge: PropTypes.func.isRequired,
    children: PropTypes.any,
};


export const MergeBodyLayout = (props) => {
    const state = useFluxStore(() => {
        const sourceLockContext = props.fluxContext;
        const targetLockContext = props.fluxContext.replace(MERGE_CONTEXT, "");
        return {
            sourceOptlock: lockStore.getOptLock(sourceLockContext),
            sourcePesslock: lockStore.getPessLock(sourceLockContext),
            targetOptlock: lockStore.getOptLock(targetLockContext),
            targetPesslock: lockStore.getPessLock(targetLockContext),
        };
    }, [
        lockStore,
    ], [
        props,
    ]);
    return (
        <MergeBodyLayoutView {...props} {...state} />
    );
};

MergeBodyLayout.propTypes = {
    isMagicRoot: PropTypes.bool,
    fluxContext: PropTypes.string.isRequired,
    targetLabel: PropTypes.any.isRequired,
    sourceLabel: PropTypes.any,
    typeLabel: PropTypes.string.isRequired,
    sourceChildren: PropTypes.array.isRequired,
    onCancel: PropTypes.func.isRequired,
    onMerge: PropTypes.func.isRequired,
    children: PropTypes.any,
};

export default MergeBodyLayout;



// WEBPACK FOOTER //
// ./app/lib/merge/mergebodylayout/MergeBodyLayout.js